import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

export interface ConnectorInfo {
  name: string;
  address: string;
}

export interface AppConfig {
  apiKey: string;
  managementApiUrl: string;
  catalogUrl: string;
  publicApiUrl: string;
  participantId?: string;
  storageAccount: string;
  storageExplorerLinkTemplate: string;
  theme: string;
  accentColor?: string;
  accentLight?: string;
  description?: string;
  maintainerOrganizationName?: string;
  curatorOrganizationName?: string;
  title?: string;
  curatorUrl?: string;
  maintainerUrl?: string;
  edcVersion?: string;
  connectorEndpoint?: string;
  connectors?: { [key: string]: ConnectorInfo };
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  config: AppConfig = environment as unknown as AppConfig;

  loadConfig(): Promise<void> {
    this.config = environment as unknown as AppConfig;
    return Promise.resolve();
  }

  getConfig(): AppConfig {
    return this.config;
  }
}
